<template>
  <!-- <div class="w-100 h-100 p-0 m-0 mx-auto">
        <Navbar />
        <router-view style="margin-top:60px"></router-view>
        <Footer />
  </div>-->

  <!-- <div class="home-dark-green-bg vw-100 min-vw-100 vh-100 min-vh-100 p-0 m-0"> -->
  <!-- <div class="home-dark-green-bg vw-100 vh-100 p-0 m-0"> vw-100 seems to cause problems... -->
  <div class="home-dark-green-bg">
    <notifications position="bottom left" />

    <LoginDialog />
    <LoadingDialog />
    <MessageDialog />

    <Navbar />
    <slot />
    
  </div>
</template>

<script>
/**
 * Represents the base template for a given view.
 * Sets itself as the base component used in App.vue 'getBaseComponent'.
 * Use this template for Frontend (i.e. views that don't require login) views.
 * NOTE: This view structucture can be replicated however many times to create different base templates (see DashboardBaseTemplate.vue).
 *
 * Includes the Alert component to set alerts at the desired spot.
 *
 * Includes BaseDialogMixin that adds the dialog functions to this view and children (inherited) views.
 * Includes BaseAlertMixin that adds the alert functions to this view and children (inherited) views.
 */

import Navbar from "@/components/frontend/Navbar.vue";
//import Footer from "@/components/frontend/Footer.vue";


import BaseDialogMixin from "@/components/mixins/BaseDialogMixin.vue";
import BaseAlertMixin from "@/components/mixins/BaseAlertMixin.vue";

import LoginDialog from "@/components/dialogs/LoginDialog.vue";
import MessageDialog from "@/components/dialogs/MessageDialog.vue";
import LoadingDialog from "@/components/dialogs/LoadingDialog.vue";

import store from "@/store/store";

import { mapActions } from "vuex";

export default {
  mixins: [BaseDialogMixin, BaseAlertMixin],
  components: {
    Navbar, // we can shorten this thanks to ES6. Otherwise it would be "Navbar: Navbar,"
    //Footer,
    LoginDialog,
    MessageDialog,
    LoadingDialog
  },
  beforeRouteEnter(to, from, next) {
    // this.setBaseComponent('BaseTemplate.vue');
    store.dispatch("setBaseComponent", "BaseTemplate");
    next();
  },
  beforeRouteUpdate(to, from, next) {
    this.setBaseComponent("BaseTemplate");
    next();
  },
  created: function() {
    this.setBaseComponent("BaseTemplate");
  },
  methods: {
    ...mapActions(["setBaseComponent"])
  }
};
</script>

<style scoped>
  /* html, body { 
    background-color: #2f4f4f !important;
  } */ /* This wasn't working ~sw */
  
  .home-dark-green-bg { 
    background-color: #2f4f4f !important;
  }

  h1 {
      text-shadow: 1px 1px 1px black;
  }
  p.outset {
      border-style: groove;
  }
  p {
      text-shadow: 1px 1px 1px black;
      font-size: large;
      color: white !important;
  }
  hr {
      display: block;
      height: 1px;
      border: 0;
      border-top: 1px solid #ccc;
      margin: 1em 0;
      padding: 0;
  }
  /* Container holding the image and the text */
  .container {
      position: relative;
      text-align: center;
      color:white;
      overflow: hidden; /* I had to add this because the "button" were appearing outside the <body> ~sw */
  }
</style>